export default function (dom, opts) {
    let options = {
        ...opts
    };


    // countEl();

    function countEl() {
        let count = dom.childElementCount;

        if (count === 2) {
            dom.classList.add('teaser-grid--2')
        } else if (count === 1) {
            dom.classList.add('teaser-grid--1')
        }
    }

}
